import { productsSlugs } from 'constants/products';

import cleanser from 'assets/images/productPages/prose-custom-cleanser.jpg';
import conditioner from 'assets/images/productPages/prose-custom-conditioner.jpg';
import curlCream from 'assets/images/productPages/prose-custom-curl-cream.jpg';
import dryShampoo from 'assets/images/productPages/prose-custom-dry-shampoo.jpg';
import hairOil from 'assets/images/productPages/prose-custom-hair-oil.jpg';
import leaveInConditioner from 'assets/images/productPages/prose-custom-leave-in-conditioner-spray-top.jpg';
import moisturizer from 'assets/images/productPages/prose-custom-moisturizer.jpg';
import hairMask from 'assets/images/productPages/prose-custom-pre-shampoo-hair-mask.jpg';
import scalpMask from 'assets/images/productPages/prose-custom-pre-shampoo-scalp-mask.jpg';
import serum from 'assets/images/productPages/prose-custom-serum.jpg';
import shampoo from 'assets/images/productPages/prose-custom-shampoo.jpg';
import stylingGel from 'assets/images/productPages/prose-custom-styling-gel.jpg';
import supplements from 'assets/images/productPages/prose-model-holding-custom-root-source-hair-supplements.jpg';

const productsStucturedData = {
  [productsSlugs.CONDITIONER]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Conditioner',
    image: conditioner.src,
    description:
      'Personalized to your unique hair, Prose Custom Conditioner is a nourishing formula to smooth, soften, and hydrate. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Haircare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-conditioner',
        priceCurrency: 'USD',
        price: '35.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-conditioner',
        priceCurrency: 'USD',
        price: '29.75',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.CURL_CREAM]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Curl Cream',
    image: curlCream.src,
    description:
      'Personalized to your natural texture, Prose Custom Curl Cream keeps curls, coils, and waves hydrated and frizz-free. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Haircare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-curl-cream',
        priceCurrency: 'USD',
        price: '32.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-curl-cream',
        priceCurrency: 'USD',
        price: '27.20',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.DRY_SHAMPOO]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Dry Shampoo',
    image: dryShampoo.src,
    description:
      'Refresh your roots with Prose Custom Dry Shampoo — a non-aerosol formula personalized to your unique scalp needs. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Haircare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-dry-shampoo',
        priceCurrency: 'USD',
        price: '32.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-dry-shampoo',
        priceCurrency: 'USD',
        price: '27.20',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.HAIR_MASK]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Pre-Shampoo Hair Mask',
    image: hairMask.src,
    description:
      'Restore moisture and shine with Prose Custom Hair Mask — a pre-shampoo treatment personalized to your unique goals. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Haircare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-hair-mask',
        priceCurrency: 'USD',
        price: '49.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-hair-mask',
        priceCurrency: 'USD',
        price: '41.65',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.HAIR_OIL]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Hair Oil',
    image: hairOil.src,
    description:
      'Shop Prose Custom Hair Oil — a nurturing, silicone-free formula with natural oils to smooth, tame, and restore hair. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Haircare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-hair-oil',
        priceCurrency: 'USD',
        price: '49.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-hair-oil',
        priceCurrency: 'USD',
        price: '41.65',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.LEAVEIN_CONDITIONER]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Leave-In Conditioner',
    image: leaveInConditioner.src,
    description:
      'Hydrate, detangle, and protect hair from heat styling damage up to 450°F with Prose Custom Leave-In Conditioner. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Haircare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-leave-in-conditioner',
        priceCurrency: 'USD',
        price: '32.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-leave-in-conditioner',
        priceCurrency: 'USD',
        price: '27.20',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.SCALP_MASK]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Pre-Shampoo Scalp Mask',
    image: scalpMask.src,
    description:
      'Purify, soothe, and restore scalp balance with Prose Custom Scalp Mask. Microbiome-friendly + fragrance-free. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Haircare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-scalp-mask',
        priceCurrency: 'USD',
        price: '49.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-scalp-mask',
        priceCurrency: 'USD',
        price: '41.65',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.SHAMPOO]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Shampoo',
    image: shampoo.src,
    description:
      'Discover Prose Custom Shampoo — a clarifying, sulfate-free shampoo personalized to your unique hair and scalp type. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Haircare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-shampoo',
        priceCurrency: 'USD',
        price: '35.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-shampoo',
        priceCurrency: 'USD',
        price: '29.75',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.STYLING_GEL]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Styling Gel',
    image: stylingGel.src,
    description:
      'Prose Custom Styling Gel is personalized for lightweight, flexible, flake-free hold — no matter your hairstyle. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Haircare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-styling-gel',
        priceCurrency: 'USD',
        price: '32.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-styling-gel',
        priceCurrency: 'USD',
        price: '27.20',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.SUPPLEMENT_CORE]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Hair Supplements',
    image: supplements.src,
    description:
      'Stimulate hair growth with Prose Custom Root Source® Hair Supplements made with natural, clean ingredients. Shop today for longer, stronger hair in 90 days.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Haircare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-hair-supplements',
        priceCurrency: 'USD',
        price: '64.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-hair-supplements',
        priceCurrency: 'USD',
        price: '54.40',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.CLEANSER]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Face Cleanser',
    image: cleanser.src,
    description:
      'Shop Prose Custom Cleanser — a gentle face wash tailored to your skin type and proven to preserve skin hydration. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Skincare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-cleanser',
        priceCurrency: 'USD',
        price: '29.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-cleanser',
        priceCurrency: 'USD',
        price: '24.65',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.MOISTURIZER]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Face Moisturizer',
    image: moisturizer.src,
    description:
      'Discover Prose Custom Moisturizer — a nourishing formula personalized with powerful, skin-boosting ingredients. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Skincare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-moisturizer',
        priceCurrency: 'USD',
        price: '52.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-moisturizer',
        priceCurrency: 'USD',
        price: '44.20',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.SERUM]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Face Serum',
    image: serum.src,
    description:
      'Personalized with potent, clinically tested ingredients, Prose Custom Serum reveals hydrated, healthy-looking skin. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Skincare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-serum',
        priceCurrency: 'USD',
        price: '64.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-serum',
        priceCurrency: 'USD',
        price: '54.50',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.SCALP_SERUM]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Scalp Serum',
    image: serum.src,
    description:
      'Shop Prose Custom Scalp Serum — a 99% natural formula to nourish your scalp and boost hair fullness and density. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Haircare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-scalp-serum',
        priceCurrency: 'USD',
        price: '56.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-scalp-serum',
        priceCurrency: 'USD',
        price: '28.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
};

export default productsStucturedData;
